/* Tour Aim – SKP product page behaviour (gallery, variants, cart, sticky bar,
   accordions, tabs, FAQ). No dependencies. */
(function () {
  'use strict';
  if (window.__skpLoaded) return;
  window.__skpLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesktop = window.matchMedia('(min-width: 768px)');

  /* ---------------- helpers ---------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function headerOffset() {
    var max = 0;
    $$('#shopify-section-header, .site-header, .header-sticky-wrapper, [data-section-type="header"], header, .announcement-bar, #SiteHeader').forEach(function (el) {
      var node = el;
      for (var i = 0; i < 3 && node; i++) {
        var pos = getComputedStyle(node).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var r = el.getBoundingClientRect();
          if (r.top <= 2 && r.bottom > 0 && r.height < window.innerHeight / 2) max = Math.max(max, r.bottom);
          break;
        }
        node = node.parentElement;
      }
    });
    return Math.round(max);
  }

  function smoothScrollTo(target) {
    if (!target) return;
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || ('$' + '{{amount}}');
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function stripZeros(str) { return str.replace(/([.,])00(?!\d)/, ''); }

  function decodeFormat(f) {
    var t = document.createElement('textarea');
    t.innerHTML = f || '';
    return t.value;
  }

  /* ---------------- autoplay videos (GIF-style) ---------------- */
  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && v.offsetParent !== null) {
        if (v.preload === 'none') v.preload = 'auto';
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.25 }) : null;

  function initAutoplay(ctx) {
    $$('[data-skp-autoplay] video', ctx).forEach(function (v) {
      if (v.__skpObs) return;
      v.__skpObs = true;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      if (videoIO && !reduceMotion) videoIO.observe(v);
    });
  }

  /* ---------------- gallery ---------------- */
  function Gallery(root) {
    this.root = root;
    this.track = $('[data-skp-track]', root);
    this.tiles = $$('[data-skp-tile]', root);
    this.thumbs = $$('[data-skp-thumb]', root);
    this.prev = $('[data-skp-prev]', root);
    this.next = $('[data-skp-next]', root);
    this.index = 0;
    var self = this;
    if (!this.track) return;

    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-skp-thumb'), 10)); });
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });

    var raf;
    this.track.addEventListener('scroll', function () {
      if (mqDesktop.matches) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = self.track.clientWidth || 1;
        var i = Math.round(self.track.scrollLeft / w);
        self.setActive(i);
      });
    }, { passive: true });

    this.updateButtons();
  }
  Gallery.prototype.orderedTiles = function () {
    return $$('[data-skp-tile]', this.track);
  };
  Gallery.prototype.go = function (i) {
    var tiles = this.orderedTiles();
    if (!tiles.length) return;
    i = Math.max(0, Math.min(tiles.length - 1, i));
    if (mqDesktop.matches) {
      smoothScrollTo(tiles[i]);
    } else {
      this.track.scrollTo({ left: tiles[i].offsetLeft - this.track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    this.setActive(i);
  };
  Gallery.prototype.setActive = function (i) {
    this.index = i;
    var tiles = this.orderedTiles();
    var activeTile = tiles[i];
    var activeOrig = activeTile ? activeTile.getAttribute('data-index') : null;
    this.thumbs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-skp-thumb') === String(i));
    });
    var activeThumb = this.thumbs.filter(function (t) { return t.classList.contains('is-active') && t.classList.contains('skp-thumb'); })[0];
    if (activeThumb && activeThumb.parentElement && !mqDesktop.matches) {
      var p = activeThumb.parentElement;
      var left = activeThumb.offsetLeft - p.clientWidth / 2 + activeThumb.clientWidth / 2;
      p.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    // pause non-active click-play videos on mobile
    tiles.forEach(function (t, idx) {
      if (idx !== i) {
        var v = t.querySelector('[data-skp-clickplay] video');
        if (v && !v.paused) v.pause();
      }
    });
    this.updateButtons();
    void activeOrig;
  };
  Gallery.prototype.updateButtons = function () {
    var n = this.orderedTiles().length;
    if (this.prev) this.prev.disabled = this.index <= 0;
    if (this.next) this.next.disabled = this.index >= n - 1;
  };
  Gallery.prototype.showMedia = function (mediaId) {
    if (!mediaId) return;
    var tiles = this.orderedTiles();
    var idx = -1;
    tiles.forEach(function (t, i) { if (t.getAttribute('data-media-id') === String(mediaId)) idx = i; });
    if (idx < 0) return;
    if (mqDesktop.matches) {
      // Desktop tiles: bring the variant media to the hero slot.
      if (idx === 0) return;
      var tile = tiles[idx];
      this.track.insertBefore(tile, this.track.firstElementChild);
      this.relayout();
    } else {
      this.go(idx);
    }
  };
  Gallery.prototype.relayout = function () {
    var tiles = this.orderedTiles();
    var run = 0, n = tiles.length;
    tiles.forEach(function (t, i) {
      var want = i === 0 ? 'full' : (t.getAttribute('data-size') || 'auto');
      var full = want === 'full' ? true : want === 'half' ? false : (i === n - 1 && run % 2 === 0);
      run = full ? 0 : run + 1;
      t.classList.toggle('skp-tile--full', full);
      t.classList.toggle('skp-tile--half', !full);
    });
  };

  /* ---------------- main product ---------------- */
  function MainProduct(root) {
    this.root = root;
    var json = $('[data-skp-product]', root);
    try { this.data = JSON.parse(json.textContent); } catch (e) { this.data = { variants: [] }; }
    this.form = $('[data-skp-form]', root);
    this.idInput = $('[data-skp-id]', root);
    this.mediaCol = $('[data-skp-media-col]', root);
    this.sticky = $('[data-skp-sticky]', root);
    var g = $('[data-skp-gallery]', root);
    this.gallery = g ? new Gallery(g) : null;
    this.moneyFmt = decodeFormat(this.data.moneyFormat);
    this.moneyCurFmt = decodeFormat(this.data.moneyWithCurrencyFormat);

    initAutoplay(root);
    this.bindOptions();
    this.bindForm();
    this.bindTooltips();
    this.bindVideoCarousels();
    this.bindCountdown();
    this.bindStickyMedia();
    this.bindStickyBar();
    this.bindAccordions();
    this.bindClickPlay();
  }

  MainProduct.prototype.money = function (cents, mode) {
    mode = mode || this.data.moneyMode;
    if (mode === 'money_with_currency') return formatMoney(cents, this.moneyCurFmt);
    if (mode === 'money_without_trailing_zeros') return stripZeros(formatMoney(cents, this.moneyFmt));
    return formatMoney(cents, this.moneyFmt);
  };

  MainProduct.prototype.bindClickPlay = function () {
    $$('[data-skp-clickplay] video', this.root).forEach(function (v) {
      var tile = v.closest('[data-skp-tile]');
      v.addEventListener('play', function () { if (tile) tile.classList.add('is-playing'); });
      v.addEventListener('pause', function () { if (tile) tile.classList.remove('is-playing'); });
    });
  };

  MainProduct.prototype.bindOptions = function () {
    var self = this;
    var groups = $$('[data-skp-option]', this.root);
    if (!groups.length) return;
    groups.forEach(function (fs) {
      $$('[data-skp-opt-input]', fs).forEach(function (input) {
        input.addEventListener('change', function () {
          $$('.skp-card', fs).forEach(function (c) { c.classList.remove('is-selected'); });
          input.closest('.skp-card').classList.add('is-selected');
          self.onOptionChange();
        });
      });
    });
    this.refreshAvailability();
  };

  MainProduct.prototype.selectedOptions = function () {
    return $$('[data-skp-option]', this.root).map(function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  };

  MainProduct.prototype.findVariant = function (opts) {
    return (this.data.variants || []).filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
    })[0];
  };

  MainProduct.prototype.refreshAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    $$('[data-skp-option]', this.root).forEach(function (fs, gi) {
      $$('[data-skp-opt-input]', fs).forEach(function (input) {
        var test = opts.slice();
        test[gi] = input.value;
        var v = self.findVariant(test);
        input.closest('.skp-card').classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  };

  MainProduct.prototype.onOptionChange = function () {
    var v = this.findVariant(this.selectedOptions());
    this.refreshAvailability();
    this.applyVariant(v);
  };

  MainProduct.prototype.applyVariant = function (v) {
    var self = this;
    var atcs = $$('[data-skp-atc]', this.root);
    if (!v) {
      atcs.forEach(function (b) { b.disabled = true; var t = b.querySelector('[data-skp-atc-text]'); if (t) t.textContent = 'Unavailable'; });
      return;
    }
    if (this.idInput) {
      this.idInput.value = v.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // price
    var now = $('[data-skp-now]', this.root);
    if (now) now.textContent = this.money(v.price);
    var onSale = v.compare_at_price > v.price;
    $$('.skp-price [data-skp-was]', this.root).forEach(function (el) { el.textContent = self.money(v.compare_at_price); el.hidden = !onSale; });
    var save = $('[data-skp-save]', this.root);
    var priceWrap = $('[data-skp-price]', this.root);
    if (save && priceWrap) {
      if (onSale) {
        var amt = v.compare_at_price - v.price;
        var pct = Math.round(amt * 100 / v.compare_at_price);
        save.textContent = (priceWrap.getAttribute('data-save-format') || 'Save [percent]%')
          .replace('[percent]', pct).replace('[amount]', stripZeros(formatMoney(amt, this.moneyFmt)));
      }
      save.hidden = !onSale;
    }
    var sNow = $('[data-skp-sticky-now]', this.root);
    if (sNow) sNow.textContent = this.money(v.price, 'money_without_trailing_zeros');
    $$('.skp-sticky [data-skp-was]', this.root).forEach(function (el) { el.textContent = self.money(v.compare_at_price, 'money_without_trailing_zeros'); el.hidden = !onSale; });
    // buttons
    atcs.forEach(function (b) {
      b.disabled = !v.available;
      var t = b.querySelector('[data-skp-atc-text]');
      if (t) t.textContent = v.available ? b.getAttribute('data-label') : b.getAttribute('data-soldout');
    });
    // url
    if (window.history && history.replaceState && this.data.url && !window.Shopify?.designMode) {
      history.replaceState({}, '', this.data.url + '?variant=' + v.id);
    }
    // media
    if (v.featured_media_id && this.gallery) this.gallery.showMedia(v.featured_media_id);
  };

  MainProduct.prototype.bindForm = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = $$('[data-skp-atc]', self.root);
      var err = $('[data-skp-error]', self.root);
      if (err) err.textContent = '';
      var id = self.idInput ? parseInt(self.idInput.value, 10) : null;
      if (!id) return;
      var items = [{ id: id, quantity: 1 }];
      $$('[data-skp-addon]', self.root).forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
      btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
          if (!res.ok || res.data.status) {
            if (err) err.textContent = res.data.description || res.data.message || 'Could not add to cart.';
            return;
          }
          var added = (res.data.items && res.data.items[0]) || res.data;
          var cartType = window.theme && window.theme.settings && window.theme.settings.cartType;
          if (cartType && cartType !== 'drawer') {
            window.location.href = root + 'cart';
            return;
          }
          // Impulse cart drawer + generic listeners
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, addToCartBtn: btns[0] } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('skp:cart-added', { detail: { items: res.data.items || [added] } }));
          if (!window.theme || !window.theme.settings) {
            window.location.href = root + 'cart';
          }
        })
        .catch(function () {
          btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
          self.form.submit();
        });
    });
  };

  MainProduct.prototype.bindTooltips = function () {
    $$('[data-skp-tip]', this.root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
      document.addEventListener('click', function (e) { if (!b.contains(e.target)) b.setAttribute('aria-expanded', 'false'); });
    });
  };

  MainProduct.prototype.bindVideoCarousels = function () {
    $$('[data-skp-vc]', this.root).forEach(function (vc) {
      var track = $('[data-skp-vc-track]', vc);
      var step = function (dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      var p = $('[data-skp-vc-prev]', vc), n = $('[data-skp-vc-next]', vc);
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  };

  MainProduct.prototype.bindAccordions = function () {
    $$('[data-skp-acc]', this.root).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) initAutoplay(d);
        $$('video', d).forEach(function (v) { if (!d.open) v.pause(); });
      });
    });
  };

  MainProduct.prototype.bindCountdown = function () {
    var els = $$('[data-skp-cd]', this.root);
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var h = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
        var now = new Date();
        var cut = new Date(now);
        cut.setHours(h, 0, 0, 0);
        if (now >= cut) cut.setDate(cut.getDate() + 1);
        var s = Math.floor((cut - now) / 1000);
        var hh = Math.floor(s / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
        el.textContent = hh + ' hr ' + mm + ' min ' + ss + ' s';
      });
    }
    tick();
    setInterval(tick, 1000);
  };

  MainProduct.prototype.bindStickyMedia = function () {
    var col = this.mediaCol;
    if (!col || !col.classList.contains('is-sticky')) return;
    var update = function () {
      if (!mqDesktop.matches) { col.style.removeProperty('--skp-media-top'); return; }
      var head = headerOffset();
      var top = Math.min(head + 16, window.innerHeight - col.offsetHeight - 16);
      col.style.setProperty('--skp-media-top', top + 'px');
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    window.addEventListener('scroll', function () { if (!col.__skpT) { col.__skpT = setTimeout(function () { col.__skpT = null; update(); }, 200); } }, { passive: true });
    $$('img', col).forEach(function (img) { if (!img.complete) img.addEventListener('load', update, { once: true }); });
  };

  MainProduct.prototype.bindStickyBar = function () {
    var bar = this.sticky;
    var mainBtn = $('.skp-buy [data-skp-atc]', this.root);
    if (!bar || !mainBtn) return;
    var self = this;
    var visible = false;
    var setVis = function (v) {
      if (v === visible) return;
      visible = v;
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      $$('button', bar).forEach(function (b) { b.tabIndex = v ? 0 : -1; });
    };
    var check = function () {
      var r = mainBtn.getBoundingClientRect();
      var pastBtn = r.bottom < headerOffset();
      var end = self.root.parentElement;
      var faq = document.getElementById('skp-faq');
      var beyond = faq ? faq.getBoundingClientRect().bottom < 0 : false;
      bar.style.setProperty('--skp-header-h', headerOffset() + 'px');
      setVis(pastBtn && !beyond);
      void end;
    };
    window.addEventListener('scroll', function () { requestAnimationFrame(check); }, { passive: true });
    window.addEventListener('resize', check);
    check();
  };

  /* ---------------- feature tabs ---------------- */
  function initTabs(root) {
    var btns = $$('[data-skp-tab]', root);
    var panels = $$('[data-skp-panel]', root);
    function activate(i, focus) {
      btns.forEach(function (b, bi) {
        var on = bi === i;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
        if (on) {
          var nav = b.parentElement;
          nav.scrollTo({ left: b.offsetLeft - nav.clientWidth / 2 + b.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
      panels.forEach(function (p, pi) {
        p.hidden = pi !== i;
        $$('video', p).forEach(function (v) { if (pi !== i) v.pause(); });
      });
      initAutoplay(panels[i]);
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { activate(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); activate((i + 1) % btns.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); activate((i - 1 + btns.length) % btns.length, true); }
      });
    });
    root.__skpActivate = activate;
    initAutoplay(root);
  }

  /* ---------------- FAQ ---------------- */
  function initFaq(root) {
    var single = root.getAttribute('data-single') === 'true';
    var items = $$('[data-skp-faq-item]', root);
    items.forEach(function (item) {
      var q = $('[data-skp-faq-q]', item);
      var a = $('[data-skp-faq-a]', item);
      if (item.classList.contains('is-open')) a.style.height = 'auto';
      q.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        if (single && open) {
          items.forEach(function (o) {
            if (o !== item && o.classList.contains('is-open')) toggle(o, false);
          });
        }
        toggle(item, open);
      });
    });
    function toggle(item, open) {
      var q = $('[data-skp-faq-q]', item);
      var a = $('[data-skp-faq-a]', item);
      var h = a.scrollHeight;
      if (open) {
        item.classList.add('is-open');
        a.style.height = h + 'px';
        var done = function () { if (item.classList.contains('is-open')) a.style.height = 'auto'; a.removeEventListener('transitionend', done); };
        a.addEventListener('transitionend', done);
        if (reduceMotion) done();
      } else {
        a.style.height = h + 'px';
        a.offsetHeight; // reflow
        a.style.height = '0px';
        item.classList.remove('is-open');
      }
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  /* ---------------- global: anchor links, init ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-skp-scroll], a[data-skp-tab-link]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    var tabIndex = a.getAttribute('data-skp-tab-link');
    if (tabIndex !== null && target.__skpActivate) target.__skpActivate(parseInt(tabIndex, 10));
    smoothScrollTo(target);
  });

  function init(ctx) {
    $$('[data-skp-main]', ctx).forEach(function (el) { if (!el.__skp) { el.__skp = new MainProduct(el); } });
    $$('[data-skp-tabs]', ctx).forEach(function (el) { if (!el.__skp) { el.__skp = true; initTabs(el); } });
    $$('[data-skp-faq]', ctx).forEach(function (el) { if (!el.__skp) { el.__skp = true; initFaq(el); } });
    initAutoplay(ctx);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-skp-panel]');
    var tabs = e.target.closest && e.target.closest('[data-skp-tabs]');
    if (panel && tabs && tabs.__skpActivate) {
      var idx = $$('[data-skp-panel]', tabs).indexOf(panel);
      if (idx > -1) tabs.__skpActivate(idx);
    }
  });
})();
